import * as types from './constants';

//  --- Setting the Initial States ---

const initialState = {
   auth: false,
   categories: [],
   categories_selected: {},
   any_categories: [],
   catalogo: [],
   productsByCategory: {},
   catalogo_filtrado: [],
   catalogo_isLoading: false,
   catalogo_vista: 'Grid',
   carrito: [],
   estados: [],
   direccion: {},
   last_prod: {},
   carrito_count: 0,
   subtotal: 0,
   paises: [],
   promotions: [],
   pedidos: [],
   pedidos_lineas: [],
   user: {},
   version: '1.0.1',
};

export default function allReducers(state = initialState, action) {
   switch (action.type) {
      case types.LOGIN:
         return {
            ...state,
            login_loading: true,
            login_error: undefined,
         };
      case types.LOGIN_ERROR:
         return {
            ...state,
            login_loading: false,
            login_error: action.error,
         };
      case types.LOGIN_SUCCESS:
         var modal = document.getElementById('modal-login');
         modal.classList.add('hidden');
         return {
            ...state,
            login_loading: false,
            login_error: action.error,
            auth: true,
            user: action.user,
            catalogo: [],
            catalogo_filtrado: [],
         };
      case types.LOGOUT:
         return {
            ...state,
            auth: false,
            user: {},
            carrito: [],
            catalogo: [],
            catalogo_filtrado: [],
            direccion: {},
            subtotal: 0,
         };

      case types.SIGNIN:
         return {
            ...state,
            login_loading: action.datos.Origen === 'ecommerce' ? true : false,
            login_facebook_loading:
               action.datos.Origen === 'facebook' ? true : false,
            login_google_loading:
               action.datos.Origen === 'google' ? true : false,
            login_error: undefined,
            sigin_message: undefined,
         };
      case types.SIGNIN_ERROR:
         return {
            ...state,
            login_loading: false,
            login_facebook_loading: false,
            login_google_loading: false,
            login_error: action.error,
            sigin_message: undefined,
         };
      case types.SIGNIN_SUCCESS:
         var modalLogin = document.getElementById('modal-login');
         modalLogin.style.display = 'none';
         return {
            ...state,
            login_loading: false,
            login_error: action.error,
            login_facebook_loading: false,
            login_google_loading: false,
            //auth: true,
            sigin_message: action.message,
         };

      case types.GET_CATEGORIES:
         return {
            ...state,
            categories_isLoading: true,
         };

      case types.GET_CATEGORIES_ERROR:
         return {
            ...state,
            categories_isLoading: false,
            error: action.error,
         };

      case types.GET_CATEGORIES_SUCCESS:
         return {
            ...state,
            categories_isLoading: false,
            categories: action.categories,
         };

      case types.GET_PRODUCTS:
         return {
            ...state,
            catalogo_isLoading: true,
            categories_selected: action.data.categoria,
         };

      case types.GET_PRODUCTS_SUCESS:
         return {
            ...state,
            catalogo_isLoading: false,
            catalogo: action.catalogo,
            catalogo_filtrado: action.catalogo,
         };

      case types.GET_HOME_PRODUCTS:
         return {
            ...state,
            isLoading: true,
         };

      case types.GET_HOME_PRODUCTS_SUCCESS:
         return {
            ...state,
            isLoading: false,
            homeProducts: action.data,
         };

      case types.OBTENER_CATALOGO:
         return {
            ...state,
            busqueda_loading: true,
         };
      case types.OBTENER_CATALOGO_ERROR:
         return {
            ...state,
            busqueda_loading: false,
            error: action.error,
         };
      case types.OBTENER_CATALOGO_SUCCESS:
         return {
            ...state,
            busqueda_loading: false,
            catalogo: action.catalogo,
            catalogo_filtrado: action.catalogo,
         };

      case types.OBTENER_CATALOGO_BUSQUEDA:
         return {
            ...state,
            busqueda_loading: true,
         };
      case types.OBTENER_CATALOGO_BUSQUEDA_ERROR:
         return {
            ...state,
            busqueda_loading: false,
            error: action.error,
         };
      case types.OBTENER_CATALOGO_BUSQUEDA_SUCCESS:
         return {
            ...state,
            busqueda: action.busqueda,
            busqueda_loading: false,
            catalogo: action.catalogo,
            catalogo_filtrado: action.catalogo,
         };

      case types.GUARDAR_DIRECCION:
         return {
            ...state,
            direccion: action.direction,
         };

      case types.FILTER_PRODUCTS:
         return {
            ...state,
            catalogo_filtrado: action.catalogo_filtrado,
         };

      case types.AGREGAR_CARRITO:
         return {
            ...state,
            carrito: action.carrito,
            carrito_count: action.carrito.length,
            last_prod: action.producto,
            subtotal: action.subtotal,
         };
      case types.AGREGAR_CARRITO_ITEM:
         return {
            ...state,
            carrito: action.carrito,
         };
      case types.QUITAR_CARRITO:
         return {
            ...state,
            carrito: action.carrito,
            carrito_count: action.carrito.length,
            last_prod: action.producto,
            subtotal: action.subtotal,
         };
      case types.CLEAN_CART:
         return {
            ...state,
            carrito: [],
            carrito_count: 0,
            subtotal: 0,
         };

      case types.PROCESAR_CARGO:
         return {
            ...state,
            payment_loading: true,
            payment: {},
         };
      case types.PROCESAR_CARGO_ERROR:
         return {
            ...state,
            payment_loading: false,
            payment: { message: 'request error' },
         };
      case types.PROCESAR_CARGO_SUCCESS:
         return {
            ...state,
            payment_loading: false,
            payment: action.payment,
         };

      case types.VERSION:
         return {
            ...state,
            version: action.version,
            carrito: [],
            carrito_count: 0,
            catalogo: [],
            catalogo_filtrado: [],
            categorias: [],
            categoria_select: {},
            pedidos: [],
            pedidos_lineas: [],
            subtotal: 0,
         };

      case types.OBTENER_ESTADOS:
         return {
            ...state,
            loading_estados: true,
         };
      case types.OBTENER_ESTADOS_ERROR:
         return {
            ...state,
            loading_estados: false,
            error: action.error,
         };
      case types.OBTENER_ESTADOS_SUCCESS:
         return {
            ...state,
            loading_estados: false,
            estados: action.estados,
         };
      case types.OBTENER_PAISES:
         return {
            ...state,
            loading_paises: true,
         };
      case types.OBTENER_PAISES_ERROR:
         return {
            ...state,
            loading_paises: false,
            error: action.error,
         };
      case types.OBTENER_PAISES_SUCCESS:
         return {
            ...state,
            loading_paises: false,
            paises: action.paises,
         };

      case types.OBTENER_PEDIDOS:
         return {
            ...state,
            pedidos_loading: true,
            pedidos: [],
         };
      case types.OBTENER_PEDIDOS_ERROR:
         return {
            ...state,
            pedidos_loading: false,
            error: action.error,
         };
      case types.OBTENER_PEDIDOS_SUCCESS:
         return {
            ...state,
            pedidos_loading: false,
            pedidos: action.pedidos,
         };
      case types.OBTENER_PEDIDOS_LINEAS:
         return {
            ...state,
            lineas_pedidos_loading: true,
         };
      case types.OBTENER_PEDIDOS_LINEAS_ERROR:
         return {
            ...state,
            lineas_pedidos_loading: false,
            error: action.error,
            pedidos_lineas: [],
         };
      case types.OBTENER_PEDIDOS_LINEAS_SUCCESS:
         return {
            ...state,
            lineas_pedidos_loading: false,
            pedidos_lineas: action.lineas,
         };

      case types.BUSQUEDA_CATALOGO:
         return {
            ...state,
            catalogo_filtrado: action.catalogo_filtrado,
         };

      default:
         return state;
   }
}



// WEBPACK FOOTER //
// ./src/redux/reducers.js